import { connect } from 'react-redux';
import View from './MarketDropsView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import { isNumericFormatted, isNumeric } from '../../../../js/app/react/validators';
import {
  principalNameSelector,
  marketDropsPercentageSelector,
  principalAgeOptionsSelector,
  principalAgeSelector,
  yearsAmountOptionsSelector,
  yearsAmountSelector,
} from './MarketDropsSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  planImpact,
  setErrors,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  isOPLMonteCarloSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  principalName: principalNameSelector(state, ownProps),
  marketDropsPercentage: marketDropsPercentageSelector(state, ownProps),
  principalAgeOptions: principalAgeOptionsSelector(state, ownProps),
  principalAge: principalAgeSelector(state, ownProps),
  yearsAmountOptions: yearsAmountOptionsSelector(state, ownProps),
  yearsAmount: yearsAmountSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  marketDropsPercentageChanged: (clientId, goalId, whatIfType) => value => {
    if (isNumericFormatted(value)) {
      dispatch(
        updateWhatIfsData(clientId, goalId, whatIfType, {
          WhatIf: {
            MarketDropsPercentage: +value.replace(/,/g, '') / 100,
          },
        }),
      );
    }
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    const errors = [];
    if (!isNumeric(whatIf.MarketDropsStartingAge)) {
      errors.push('Please select the starting age.');
    }
    if (!isNumeric(whatIf.MarketDropsNumYears)) {
      errors.push('Please select the number of years.');
    }
    if (errors.length) {
      dispatch(setErrors(clientId, errors));
    } else {
      dispatch(
        applyWhatIf(
          clientId,
          fpId,
          goalId,
          whatIf,
          RouteDictionary[whatIfTemplate.WhatIfType],
          Object.keys(whatIfTemplate),
          whatIfTemplate.WhatIfType,
        ),
      );
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
